const THINK_THIN_DATA = [ {
        media: 'video playa corto mp4.mp4',
        description:
            'Helps provide for a smooth absorption of nutrients while eliminating toxins out of the body.',
        logo: '1',
        id: '01',
        ingredients: [
            'Leptin',
            'African Mango',
            'Alpha-Lipoic Acid',
            'Fish Oil',
            'Green Tea Extract',
            'Conjugated Linoleic Acid',
            'Lipase',
            'Glucagon',
            'Adrenaline',
            'T3',
            'T4',
            'Testosterone',
            'Chromium',
            'Garcinia Cambogia',
            'Bitter Orange',
            'Coleus forskohlii',
            'Beta Glucans',
            'Raspberry Ketones',
            'Caffeine',
            'Capsaicin',
            'Hoodia',
            'Probiotics',
            'Prebiotics',
            'Harmonized Water',
            'Green Coffee Bean Extract',
            'Fucoxanthin',
            'Carnitine',
            'Pyruvate',
            'Guarana',
            'Yohimbe',
            'Vitamin D',
            'Glucomannan',
            'Chitosan',
            'Vitamin C',
            'Vitamin A',
            'Progesterone',
            'DHEA',
            'Guar Gum',
            'Chamomile',
            'Kava Kava',
            'Lavender',
            'Skullcap',
            'Passion Flower',
        ],
        name: 'Think Thin',
    },
];

export default THINK_THIN_DATA;